<script lang="ts">
  import { defineComponent } from "vue";

  export default defineComponent({
    name: "LogoLoading",
  });
</script>

<template>
  <div class="icon">
    <i class="anticon logo">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1024 1024"
        style="width: 1em; height: 1em; vertical-align: middle"
        class="icon"
        fill="currentColor"
        overflow="hidden">
        <path
          fill="#4285F4"
          d="M944.32 460.48A471.168 471.168 0 0 0 498.304 144 475.584 475.584 0 0 0 22.656 613.568v6.08c0 131.328 106.304 238.016 238.016 238.016S498.688 751.36 498.688 619.648c0-65.28 26.432-124.544 68.864-167.36l.384.384v-.384a236.8 236.8 0 0 1 168.768-70.272c62.784 0 165.184 37.824 207.616 78.464zm38.912 101.376-15.36-2.496 5.76 14.976 15.296 2.112zm-11.776-34.24-20.672-2.88 8.192 20.352 20.672 2.816zm-17.472-47.872-26.048-3.904 9.984 25.728 26.432 3.52z" />
        <path
          fill="#4285F4"
          d="m876.16 512.576-20.672-3.2 7.872 20.736 21.056 2.816zm47.872 8.256-21.056-3.264 8.192 20.352 21.056 3.2zm-15.36-46.4-26.048-3.584 9.984 25.344 26.368 3.584z" />
        <path fill="#43AD5E" d="m863.68 468.736-26.048-3.968L848 490.496l26.048 3.52z" />
        <path fill="#4285F4" d="m935.04 435.2-26.368-3.968 10.304 25.728 26.048 3.52z" />
        <path fill="#FBBC05" d="m893.696 430.528-26.048-3.584 9.984 25.344 26.048 3.584z" />
        <path fill="#F04B43" d="m845.888 423.04-26.432-3.584 10.368 25.344 26.048 3.584z" />
        <path
          fill="#43AD5E"
          d="M769.472 562.56c12.48 10.688 15.36 29.632 6.4 43.904a33.536 33.536 0 0 1-46.72 9.984 33.536 33.536 0 0 1-9.984-46.72 33.536 33.536 0 0 1 46.72-9.984c.384.384.704.704 1.408 1.088a74.24 74.24 0 1 0 2.176 1.728zm-2.496-2.176c.704.704 1.792 1.408 2.496 2.112-.704-.64-1.728-1.344-2.496-2.112z" />
      </svg>
    </i>
    <svg class="circle" viewBox="25 25 50 50">
      <circle class="loader-path" cx="50" cy="50" r="20" />
    </svg>
  </div>
</template>

<style lang="less" scoped>
  .icon {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    margin: 0 auto;

    // margin: 0 !important;
    .logo {
      position: absolute;
      top: 50%;
      left: 50%;
      font-size: 28px;
      background: none !important;
      transform: translate(-50%, -50%);

      svg {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .circle {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      transform-origin: center center;
      animation: rotate 2s linear infinite;

      .loader-path {
        fill: none;
        stroke: var(--primary-color);
        stroke-dasharray: 150, 200;
        stroke-dashoffset: -10;
        stroke-linecap: round;
        stroke-width: 1;
        animation:
          dash 1.5s ease-in-out infinite,
          color 3s ease-in-out infinite;
      }
    }
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }

    50% {
      transform: rotate(180deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 200;
      stroke-dashoffset: 0;
    }

    50% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -35;
    }

    100% {
      stroke-dasharray: 89, 200;
      stroke-dashoffset: -124;
    }
  }
</style>
